export const calendarUrl = 'https://calendly.com/marcell-ortutay/fetchfox';
export const discordUrl = 'https://discord.gg/mM54bwdu59';
export const docsUrl = 'https://docs.fetchfox.ai';

export const primaryColor = '#FD953A';
export const primaryColorDark = '#EC6105';

export const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

export const headerHeight = 50;

// TODO: refactor to remove redundant variables
export const colors = {
  primary: primaryColor,
  primaryDark: primaryColorDark,
  primaryLight: '#fff2e6',

  brightBlue: '#0275ff',
  lightBlue: '#def',

  brightGreen: '#16A34A',
  lightGreen: '#D1FAE5',

  brightPurple: '#8B5CF6',
  lightPurple: '#F3E8FF',

  brightOrange: '#F97316',
  lightOrange: '#FFEDD5',

  brightYellow: '#D97706',
  lightYellow: '#FEF9C3',

  linkBlue: 'rgb(9, 105, 218)',
  gray: '#eee',

  green: '#27ae60',
  darkGreen: '#1e8449',
  lightGreen: '#a9dfbf',

  error: '#dc2626',
  lightError: '#f87171',
};

export const styles = {
  uiBox: {
    border: '1px solid #ccc',
    padding: 10,
    borderRadius: 8,
  },

  textOverflowStyle: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};
